import { createSelector } from 'reselect';
import { getIsErpJobDispatchEnabled } from 'lib/selectors/getIsErpJobDispatchEnabled';
import { getIsMesBehaviorMode } from 'lib/selectors/getIsMesBehaviorMode';
import { getIsMESEnabled } from 'lib/selectors/getIsMESEnabled';
import { getIsMESErpJobDispatchEnabled } from 'lib/selectors/getIsMESErpJobDispatchEnabled';

/**
 * Returns true when jobs are driven by ERP.
 * When MES is enabled, the machine-level erpJobDispatchEnabled flag is a
 * denormalized mirror of the company-wide job mode (erpJobDispatchEnabledAt),
 * so either signals ERP-driven; the company fallback covers machines whose
 * mirror flag was never stamped (KGM-119).
 * Otherwise, falls back to legacy company-level dispatch settings.
 */
export const getIsErpDriven = createSelector(
  [
    getIsErpJobDispatchEnabled,
    getIsMesBehaviorMode,
    getIsMESEnabled,
    getIsMESErpJobDispatchEnabled,
  ],
  (
    isErpJobDispatchEnabled,
    isMesBehaviorMode,
    isMESEnabled,
    isMESErpJobDispatchEnabled
  ) => {
    if (isMESEnabled) {
      return isMESErpJobDispatchEnabled || isErpJobDispatchEnabled;
    }
    return isErpJobDispatchEnabled && isMesBehaviorMode;
  }
);
